import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, NAV } from "../lib/company";

export default function Footer() {
  return (
    <footer
      className="bg-[#111827] text-white"
      data-testid="site-footer"
    >
      <div className="diagonal-stripes h-3 w-full" />
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="bg-white p-4 inline-block">
              <img
                src={COMPANY.logoUrl}
                alt="Humlegruppen"
                className="h-14 w-auto object-contain"
                data-testid="footer-logo-image"
              />
            </div>
            <p className="mt-6 text-gray-300 leading-relaxed max-w-md text-base">
              Humlegruppen samlar två starka verksamheter under ett tak — Humle
              Åkeri AB och Humle Entreprenad AB. Vi levererar transport och
              entreprenad med kraft, precision och tillförlitlighet sedan
              decennier tillbaka.
            </p>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <p className="overline text-[#FFD700] mb-5">Navigation</p>
            <ul className="space-y-3">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid={`footer-${item.testid}`}
                    className="text-gray-200 hover:text-[#FFD700] transition-colors font-condensed uppercase tracking-wider text-base"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <p className="overline text-[#FFD700] mb-5">Kontakt</p>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[#FFD700] mt-1 shrink-0" />
                <a
                  href={COMPANY.phoneHref}
                  className="hover:text-[#FFD700] transition-colors"
                  data-testid="footer-phone"
                >
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#FFD700] mt-1 shrink-0" />
                <a
                  href={COMPANY.emailHref}
                  className="hover:text-[#FFD700] transition-colors break-all"
                  data-testid="footer-email"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin
                  size={18}
                  className="text-[#FFD700] mt-1 shrink-0"
                />
                <address
                  className="not-italic text-gray-200 leading-relaxed"
                  data-testid="footer-address"
                >
                  {COMPANY.legal}
                  <br />
                  {COMPANY.address.street}
                  <br />
                  {COMPANY.address.zip} {COMPANY.address.city}
                </address>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-800 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p
            className="text-sm text-gray-400 font-condensed uppercase tracking-wider"
            data-testid="footer-copyright"
          >
            © {new Date().getFullYear()} Humlegruppen — Alla rättigheter
            förbehållna
          </p>
          <p className="text-sm text-gray-500 font-condensed uppercase tracking-wider">
            Tungelsta · Sverige
          </p>
        </div>
      </div>
    </footer>
  );
}
